import { render, staticRenderFns } from "./AreaGoods.vue?vue&type=template&id=3ec469ef&"
import script from "./AreaGoods.vue?vue&type=script&lang=js&"
export * from "./AreaGoods.vue?vue&type=script&lang=js&"
import style0 from "./AreaGoods.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports